exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".align-end{text-align:right}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/info/VisitPanel.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"VisitPanel.vue","sourcesContent":["\n.align-end{\r\n  text-align: right;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-43c99fd2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/info/VisitPanel.vue
// module id = 1085
// module chunks = 1